import { Avatar } from "@mui/material";
import React, { useState } from "react";
import "../css/navbar.css";
import { useAuth } from "../contexts/AuthContext";
import { getRoleColor } from "../utils/roleColors";

export default function ProfileWidget(props) {
  const { currentUser } = useAuth();
  const [displayedName] = useState(currentUser ? currentUser.displayName : "");
  const [photoUrl] = useState(currentUser ? currentUser.photoURL : "");
  const roleColor = getRoleColor(props.userRole);

  return (
    <div className="widget-profile-container">
      <div className="avatar-container">
        <Avatar
          src={photoUrl}
          style={{
            width: "30px",
            height: "30px",
            border: "2px solid white",
          }}
        />
      </div>
      <div className="profil-widget-container">
        <div className="container-chip-role-profile">
          <div
            className="profil-name"
            title={displayedName}
            style={{ cursor: "pointer" }}
          >
            <span className="displayed-name-span" style={{ fontSize: "12px" }}>
              {displayedName}
            </span>
          </div>
        </div>
        <div className="container-chip-role-profile">
          <div
            className="profil-role"
            style={{ background: roleColor, fontSize: "8px" }}
          >
            {props.userRole}
          </div>
        </div>
      </div>
    </div>
  );
}
